import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=f1d5ab58&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jeroen/VirtualHosts/deduursportcoach.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1d5ab58')) {
      api.createRecord('f1d5ab58', component.options)
    } else {
      api.reload('f1d5ab58', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=f1d5ab58&", function () {
      api.rerender('f1d5ab58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/errors/PageNotFound.vue"
export default component.exports